import React from 'react';
import { FileText, Flask, ShoppingCart, Tooth } from '@phosphor-icons/react';
import type { CtaIcon } from '../../data/deck';
export function CtaGlyph({
  icon,
  size = 20
}: {
  icon: CtaIcon;
  size?: number;
}) {
  if (icon === 'cases') return <FileText size={size} aria-hidden="true" data-id="element-87" data-mp="2r0hcahzvp2wf" />;
  if (icon === 'procedures') return <Tooth size={size} aria-hidden="true" data-id="element-88" data-mp="2m2zd3jbny21m" />;
  if (icon === 'trial') return <Flask size={size} aria-hidden="true" data-id="element-89" data-mp="1yc27spedi2zc" />;
  return <ShoppingCart size={size} aria-hidden="true" data-id="element-90" data-mp="1ycv5z1z9nk5v" />;
}